<template>
  <transition v-if="product && !(isOutOfStock || isComingSoon)" name="fade">
    <div
      v-if="showStickyCta"
      class="sticky z-1 w-full bg-white shadow-md md:fixed <md:bottom-0"
      :style="{ top: stickyHeaderTop }"
    >
      <base-sticky name="stickyProductCta">
        <div class="flex items-center gap-4 container <md:py-2 !py-2" style="min-height: 4rem">
          <base-picture
            v-if="galleryItems[0].src"
            :alt="galleryItems[0].alt"
            class="h-16 w-a shrink-0 <md:hidden"
            :height="stickyHeader?.thumbnail.height"
            :src="galleryItems[0].src"
            :width="stickyHeader?.thumbnail.width"
          />
          <div class="f-col gap-2 truncate <md:hidden gap-4">
            <span
              class="truncate title-3"
              data-dynatrace="product-name"
              data-test-id="product-name"
            >
              {{ product.name }}
            </span>
            <product-pricing
              v-if="productPrice"
              class="text-sm"
              :currency="product.currency"
              :price="productPrice"
            />
          </div>
          <div class="ml-a shrink-0 <md:w-full <md:flex <md:gap-1 <md:between">
            <vf-button
              aria-live="polite"
              class="flex-1"
              :class="{ 'c-white': isSignInToBuy && theme }"
              :disabled="pending || addToCartLoading || checkoutCtaLoading"
              :loading="addToCartLoading && !checkoutCtaLoading"
              :size="{ sm: 'sm', md: 'xs' }"
              :theme="isSignInToBuy ? theme : undefined"
              :variant="isSignInToBuy && theme ? 'themable' : 'primary'"
              @click="addToCart"
            >
              {{ ctaLabel }}
            </vf-button>
            <vf-button
              v-if="$feature.showCheckoutOnPDP"
              aria-live="polite"
              class="flex-1 md:hidden"
              :disabled="pending || addToCartLoading || checkoutCtaLoading"
              :loading="checkoutCtaLoading"
              :size="{ sm: 'sm' }"
              variant="secondary"
              @click="addToCartAndCheckout"
            >
              {{ $t.checkout }}
            </vf-button>
          </div>
        </div>
      </base-sticky>
    </div>
  </transition>
  <slot name="compare" />
</template>

<script setup lang="ts">
const { showStickyHeader, stickyHeader } = useAppConfig().pages.pdp
const { card: { signInToBuyCta: { theme } } } = useAppConfig().components.product
const header = useHeaderStore()
const { $t, $viewport } = useNuxtApp()
const {
  addToCart,
  addToCartAndCheckout,
  addToCartLoading,
  checkoutCtaLoading,
  galleryItems,
  isComingSoon,
  isOutOfStock,
  isSignInToBuy,
  pending,
  product,
  productPrice,
  selectedVariant
} = usePdp()
const { y } = useScroll(document)
const stickyState = useSticky()

const { top: productDetailsCtaTop } = useElementBounding(() => stickyState.value.productDetailsCta)
const isVisible = useElementVisibility(useState('productDetailsCtaRef'))

const ctaLabel = computed(() => {
  if (isSignInToBuy.value) return $t.signInToBuy
  if (selectedVariant.value) return $t.addToCart
  return $t.chooseSize
})

const showStickyCta = computed(
  () => ($viewport.breakpoint === 'sm' || y.value > header.height.navigation) && !isVisible.value
)

const stickyHeaderTop = computed(
  () => !showStickyHeader && !header.pageScrolledUp
    ? '0'
    : productDetailsCtaTop.value < 0 && !header.pageScrolledUp
      ? pxToRem(header.sticky.offset)
      : pxToRem(header.sticky.margin)
)
</script>
